export default "__VITE_ASSET__Cto5O8SL__"